import { useState, useCallback, useEffect } from "react";

// libraries

import PaymentModal from "../../components/payment/paymentDialog";
import { Container } from "@mui/material";
import { checkPaymentStatus } from "../../setup/api/services/payment";

import { useSearchParams } from "react-router-dom";
import Result from "../../components/payment/paymentMethods/result";

// libraries
import { useNavigate } from "react-router";
import { doAction } from "../../setup/api/services/contractActions";
import { EContractActions } from "../../setup/api/services/contractActions/enum";
import { IContractActionRequestBody } from "../../setup/api/services/contractActions/models";
import {
  ACTION_UNDER_PROCESSING,
  CANNOT_MAKE_THIS_CALL,
} from "../contract/constants";
import { getUserId } from "../../setup/auth/oidc";
import { getContractDetails } from "../../setup/api/services/contract";
import {
  ESenderRole,
  IContractDetailsResponseData,
} from "../../setup/api/services/contract/models";

export enum MessageType {
  NONE = "NONE",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}
let hack = false;
const Payment = () => {
  const [open, setOpen] = useState(false);
  const [messageType, setMessageType] = useState<MessageType>(MessageType.NONE);
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const contractId = searchParams.get("contractId");
  const userId = getUserId();
  const handleClose = useCallback(() => setOpen(false), []);
  const getActorType = (contract: IContractDetailsResponseData) => {
    if (contract.senderId == userId) return ESenderRole.PROVIDER;
    else return ESenderRole.CUSTOMER;
  };

  const buyerFundAction = async (contractId: string, checkoutId: string) => {
    if (!userId) return;
    const response = await getContractDetails(contractId);
    const contract = response.data;
    const body: IContractActionRequestBody = {
      contractId: contract.id,
      userId: userId,
      actorRole: getActorType(contract),
      receiverId: contract?.receiverId || userId,
      senderId: contract.senderId,
      contractAction: EContractActions.ADMIN_CLOSE_REFUND_CUSTOMER,
      transactionId: checkoutId,
    };
    doContractAction(body);
  };
  const doContractAction = (body: IContractActionRequestBody) => {
    doAction(body)
      .then((res) => {
        if (res.sent === true) {
          console.log(ACTION_UNDER_PROCESSING, "success");
        } else {
          console.log(CANNOT_MAKE_THIS_CALL, "error");
        }
      })
      .catch(() => {
        console.log(CANNOT_MAKE_THIS_CALL, "error");
      });
  };
  const checkStatus = async (id: string) => {
    try {
      const result = await checkPaymentStatus(id);
      setOpen(true);
      if (result?.successful) {
        if (contractId && id) buyerFundAction(contractId, id);
        setMessageType(MessageType.SUCCESS);
      } else {
        setMessageType(MessageType.ERROR);
      }
    } catch (error) {
      setOpen(true);
      setMessageType(MessageType.ERROR);
    }
    setTimeout(() => {
      navigate(-1);
    }, 5000);
  };

  useEffect(() => {
    if (id && !hack) {
      hack = true;
      checkStatus(id);
    }
  }, [id, searchParams]);

  const handleForm = useCallback(() => {
    if (messageType === MessageType.SUCCESS) handleClose();
    else {
      setMessageType(MessageType.NONE);
      navigate(-1);
    }
  }, [handleClose, messageType, navigate]);

  return (
    <Container>
      <PaymentModal open={open} handleClose={handleClose}>
        <Result messageType={messageType} handleSubmit={handleForm} />
      </PaymentModal>
    </Container>
  );
};

export default Payment;
